export { StudentSubjectResultsDrawer } from './student-subject-results-drawer';

export type { StudentSubjectResultsDrawerProps } from './student-subject-results-drawer';
